import { FlagProps } from "react-phone-number-input";
import flags from "react-phone-number-input/flags";

import styles from "./CountryFlag.module.scss";

type CountryDialCodeProps = FlagProps;

export const CountryFlag = ({ country, countryName }: CountryDialCodeProps) => {
  const Flag = flags[country];

  return (
    <span className={styles.flag}>{Flag && <Flag title={countryName} />}</span>
  );
};
